/**
 * BLOCK: POSTS CAROUSEL
 */
'use strict'

// jQuery(document).ready(function($) {
// 	/**
// 	 * Instansiate Owl Carousel for posts-carousel block but ONLY if it exists on page.
// 	 */
//
// 	function instantiate_owls(){
// 		$("#gut__postscarousel--carousel-1").owlCarousel({
// 			'items': 1,
// 			'loop': true,
// 			'margin': 100,
// 			'navText': ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>']
// 		});
// 		$("#gut__postscarousel--carousel-2").owlCarousel({
// 			'items': 1,
// 			'loop': true,
// 			'margin': 100,
// 			'navText': ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>']
// 		});
// 	}
//
//
//
// 	if ($('.wp-admin').length > 0) {
// 		console.log('wp-admin detected');
// 		setTimeout(function(){
// 			if ( $('.gut__postscarousel').length > 0 ) {
// 				instantiate_owls()
// 			}
// 		},2000)
// 	} else {
// 		if ( $('.gut__postscarousel').length > 0 ) {
// 			instantiate_owls()
// 		}
// 	}
//
// 	/**
// 	 * CONTROLS BLOCK: POSTS-CAROUSEL STUFF
// 	 */
// 	$(document).on( 'click', '.gut__postscarousel--tab-navigation-trigger', function(e) {
// 		e.preventDefault();
// 		if ($(this).hasClass('.gut__postscarousel--tab-navigation-trigger-active')) {
// 			// already selected
// 		} else {
// 			// new selection
// 			// remove active class from other buttons
// 			$('.gut__postscarousel--tab-navigation-trigger-active').removeClass('gut__postscarousel--tab-navigation-trigger-active');
// 			// Add active class to this button
// 			$(this).addClass('gut__postscarousel--tab-navigation-trigger-active');
// 			const tab = $(this).attr('data-tab');
// 			$('.gut__postscarousel--tab-active').removeClass('gut__postscarousel--tab-active');
// 			$( '#gut__postscarousel--carousel-' + tab ).addClass('gut__postscarousel--tab-active');
// 		}
// 	});
// });
